import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
  selector: 'pptl-modal-what-is-pp',
  templateUrl: './modal-what-is-pp.component.html',
  styleUrls: ['./modal-what-is-pp.component.scss'],
})
export class ModalWhatIsPpComponent {
  constructor(public modalController: ModalController) {}

  onCancelButtonClick(): void {
    this.modalController.dismiss();
  }
}
